/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type GetConversationGroupConversationGroupsConversationGroupIdGetParams =
  {
    /**
     * Number of messages per page
     * @minimum 1
     * @maximum 100
     */
    limit?: number;
    /**
     * Pagination cursor for next page
     */
    cursor?: string | null;
  };
